import { render, staticRenderFns } from "./user_detail.vue?vue&type=template&id=a1d9190a&scoped=true&"
import script from "./user_detail.vue?vue&type=script&lang=js&"
export * from "./user_detail.vue?vue&type=script&lang=js&"
import style0 from "./user_detail.vue?vue&type=style&index=0&id=a1d9190a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d9190a",
  null
  
)

export default component.exports